module.exports = __webpack_public_path__ + "assets/f6bb7fc783f0d414c3605bcc8d6b94fd.png";